import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';

import { Heading } from '../../components';
import UserCard from './UserCard/UserCard';

import css from './ListingPage.module.css';

/**
 * Author / about-provider section for cover-photo listing layout.
 * Contact lives on the seller Profile page (XenForo DM), not here.
 */
const SectionAuthorMaybe = props => {
  const { listing, currentUser } = props;

  if (!listing.author) {
    return null;
  }

  return (
    <section id="author" className={css.sectionAuthor}>
      <Heading as="h2" rootClassName={css.sectionHeadingWithExtraMargin}>
        <FormattedMessage id="ListingPage.aboutProviderTitle" />
      </Heading>
      <UserCard user={listing.author} currentUser={currentUser} showContact={false} />
    </section>
  );
};

export default SectionAuthorMaybe;
